import {UPDATE_MAGAZINE_ERROR, UPDATE_MAGAZINE_START, UPDATE_MAGAZINE_SUCCESS} from "../../types";

export default function update_magazine(state, action) {
    switch (action.type) {
        case UPDATE_MAGAZINE_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_MAGAZINE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case UPDATE_MAGAZINE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
